export default {
    title: state => {
        return state.title;
    },
    medicalSpecialties: state => {
        return state.medicalSpecialties;
    },
    medicalSpecialty: state => {
        return state.medicalSpecialty;
    },
    medicalSpecialtyToEdit: state => {
        return state.medicalSpecialtyToEdit;
    },
    total: state => {
        return state.total;
    }
}
